import { NgModule } from '@angular/core';

import { ChBaseComponent } from './ch-base.component';

@NgModule({
    exports: [ChBaseComponent],
    declarations: [ChBaseComponent]
})
export class ChBaseModule { }
